import client from "./client";

export const register = async (param) => {
  return await client({
    url: `/auth/register`,
    method: "post",
    data: {
      username: param.username,
      password: param.password,
      name: param.name,
      birth: param.birth,
      phone: param.phone,
      gender: param.gender,
    },
  });
};

export const login = async ({ username, password }) => {
  return await client({
    url: `/auth/login`,
    method: "post",
    data: {
      username,
      password,
    },
  });
};

export const checkDuplicateUsername = async (data) => {
  return await client({
    url: `/auth/check-duplicate-username`,
    method: "post",
    data,
  });
};

export const resetPassword = async (data) => {
  return await client({
    url: `/auth/reset-password`,
    method: "post",
    data,
  });
};

export const refreshToken = async () => {
  return await client({
    url: `/auth/refresh-token`,
    method: "post",
  });
};

export const logout = async () => {
  return await client({
    url: `/auth/logout`,
    method: "GET",
  });
};
